import { createActionTypes } from "../../../utils";

// eslint-disable-next-line import/no-anonymous-default-export
export default {
  ...createActionTypes("CERTIFICATE", "FETCH_CERTIFICATE"),
  ...createActionTypes("CERTIFICATE", "REVOKE_CERTIFICATE"),
};

export const CLEAR_PIN_PASSWORD = "CLEAR_PIN_PASSWORD"
